// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__rQauX","List":"Loading_List__6dQDG","ListItem":"Loading_ListItem__cVoAf","Oval":"Loading_Oval__CXGWk","Footer":"Loading_Footer__cLDd6"};